<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">탕전 주문상세 내역</h2>
        </section>
        <section class="view">
          <h2 class="page_title">주문정보</h2>
            <div class="table_list mb40">
              <table class="write">
                <colgroup>
                  <col width="200">
                  <col width="400">
                  <col width="200">
                  <col width="400">
                </colgroup>
                <tbody>
                  <tr>
                    <th><span>주문번호</span></th>
                    <td>{{orderPaymentInfo.order_code}}</td>
                    <th><span>주문일자</span></th>
                    <td>{{orderPaymentInfo.reg_dt}}</td>
                  </tr>
                  <tr>
                    <th><span>조제상태</span></th>
                    <td>{{orderPaymentInfo.work_status_nm}}</td>
                    <th><span>결제상태</span></th>
                    <td>{{orderPaymentInfo.payment_status_nm}}</td>
                  </tr>
                  <tr>
                    <th><span>처방 한의원</span></th>
                    <td>{{orderPaymentInfo.clinic_nm}}</td>
                    <th><span>처방의</span></th>
                    <td>{{orderPaymentInfo.doctor_nm}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          <h2 class="page_title">환자정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="400">
                <col width="200">
                <col width="400">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>차트번호</span></th>
                  <td>{{orderPaymentInfo.patient_chart_no}}</td>
                  <th><span>환자명</span></th>
                  <td>{{orderPaymentInfo.patient_nm}}</td>
                </tr>
                <tr>
                  <th><span>성별</span></th>
                  <td>{{orderPaymentInfo.patient_gender_nm}}</td>
                  <th><span>나이</span></th>
                  <td>{{orderPaymentInfo.patient_age}}</td>
                </tr>                                   
              </tbody>
            </table>
          </div>
          <h2 class="page_title">처방정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="400">
                <col width="200">
                <col width="400">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>처방명</span></th>
                  <td>{{orderPaymentInfo.prescribe_nm}}</td>
                  <th><span>출전</span></th>
                  <td>{{orderPaymentInfo.prescribe_source}}</td>
                </tr>                               
                <tr>
                  <th>처방 약재정보</th>
                  <td colspan="4">
                    <div class="table_list">
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>약재명</th>
                            <th>원산지</th>
                            <th>첩량</th>
                            <th>약재량</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in orderMedicineList" :key="index">
                            <td><span>{{ item.med_hrb_nm }}</span></td>
                            <td><span>{{ item.org_plce_nm }}</span></td>
                            <td>
                              <span>{{ item.medicine_use_qnty }}</span>
                            </td>
                            <td>
                              <span>{{ item.medicine_use_qnty * 20}}g</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>    
                <tr>
                  <th><span>처방메모</span></th>
                  <td colspan="4"><pre>{{orderPaymentInfo.prescribe_note}}</pre></td>
                </tr>    
                <!-- <tr>
                  <th><span>녹용&#40;앰플&#41;</span></th>
                  <td>{{orderPaymentInfo.ny_ampul}}</td>
                  <th><span>자하거&#40;앰플&#41;</span></th>
                  <td>{{orderPaymentInfo.jhg}}</td>
                </tr>                       -->
                <tr>
                  <th><span>첩수</span></th>
                  <td>{{orderPaymentInfo.prescribe_pack_cnt}} 첩</td>
                  <th><span>총약재량</span></th>
                  <td>{{orderPaymentInfo.total_medicine_qnty}}g</td>
                </tr>                      
                <tr>
                  <th><span>팩용량</span></th>
                  <td>{{orderPaymentInfo.pack_capacity}} ml</td>
                  <th><span>팩수</span></th>
                  <td>{{orderPaymentInfo.packs_cnt}} 팩</td>
                </tr>                      
              </tbody>
            </table>
          </div>
          <h2 class="page_title">포장정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="400">
                <col width="200">
                <col width="400">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>파우치</span></th>
                  <td>
                    <div class="img_list">
                        <div>
                            <img :src="'/file/getImgFile/' + orderPaymentInfo.pouch_img_file_id" alt="">
                            <p>{{ orderPaymentInfo.pouch_wraaper_nm }}</p>
                        </div>
                    </div>
                  </td>
                  <th><span>포장</span></th>
                  <td>
                    <div class="img_list">
                        <div>
                            <img :src="'/file/getImgFile/' + orderPaymentInfo.wrapper_type_img_file_id" alt="">
                            <p>{{ orderPaymentInfo.wrapper_type_nm }}</p>
                        </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>박스</span></th>
                  <td>
                    <div class="img_list">
                        <div>
                            <img :src="'/file/getImgFile/' + orderPaymentInfo.box_img_file_id" alt="">
                            <p>{{ orderPaymentInfo.box_wrapper_nm }}</p>
                        </div>
                    </div>
                  </td>
                  <th><span>마킹</span></th>
                  <td>
                    {{ orderPaymentInfo.mark_yn }}
                  </td>
                </tr>                                       
              </tbody>
            </table>
          </div>                                 
          <h2 class="page_title">배송정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <tbody>
                <tr>
                  <th><span>배송타입</span></th>
                  <td colspan="4">{{ orderPaymentInfo.delivery_type_nm }}</td>
                </tr>                                      
                <tr>
                  <th rowspan="3"><span>보내는 사람</span></th>
                  <th><span>발신인</span></th>
                  <td colspan="4">{{ orderPaymentInfo.send_nm }}</td>
                </tr>             
                <tr>
                  <th><span>연락처</span></th>
                  <td>{{ formatPhoneNumber(orderPaymentInfo.send_tel_num) }}</td>
                  <th><span>핸드폰</span></th>
                  <td>{{ formatPhoneNumber(orderPaymentInfo.send_phone_num) }}</td>
                </tr>                         
                <tr>
                  <th><span>우편번호</span></th>
                  <td>{{ orderPaymentInfo.send_post_no }}</td>
                  <th><span>주소</span></th>
                  <td>{{ orderPaymentInfo.send_addr }} {{ orderPaymentInfo.send_addr_dtl }}</td>
                </tr>                         
                <tr>
                  <th rowspan="3"><span>받는 사람</span></th>
                  <th><span>수신인</span></th>
                  <td colspan="4">{{ orderPaymentInfo.receive_nm }}</td>
                </tr>             
                <tr>
                  <th><span>연락처</span></th>
                  <td>{{ formatPhoneNumber(orderPaymentInfo.receive_tel_num) }}</td>
                  <th><span>핸드폰</span></th>
                  <td>{{ formatPhoneNumber(orderPaymentInfo.receive_phone_num) }}</td>
                </tr>                         
                <tr>
                  <th><span>우편번호</span></th>
                  <td>{{ orderPaymentInfo.receive_post_no }}</td>
                  <th><span>주소</span></th>
                  <td>{{ orderPaymentInfo.receive_addr }} {{ orderPaymentInfo.receive_addr_dtl }}</td>
                </tr>                         
              </tbody>
            </table>
          </div>            
          <h2 class="page_title">택배사 정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="400">
                <col width="200">
                <col width="400">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>택배사</span></th>
                  <td colspan="4">{{ orderPaymentInfo.delivery_company_nm }}</td>
                </tr>                                      
                <tr>
                  <th><span>송장번호</span></th>
                  <td>{{ orderPaymentInfo.delivery_no }}</td>
                  <th><span>배송상태</span></th>
                  <td></td>
                </tr>                                      
              </tbody>
            </table>
          </div>                                 
          <h2 class="page_title">결제 정보</h2>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="400">
                <col width="200">
                <col width="400">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>결제방법</span></th>
                  <td>카드결제</td>
                  <th><span>결제금액</span></th>
                  <td>{{ fn_comma_won(orderPaymentInfo.total_payment) }}원</td>
                </tr>                                      
                <tr>
                  <th><span>포인트 사용</span></th>
                  <td>0p</td>
                  <th><span>잔여포인트</span></th>
                  <td>0P</td>
                </tr>                                      
                <tr>
                  <th><span>실제 결제 금액</span></th>
                  <td colspan="4">{{ fn_comma_won(orderPaymentInfo.total_payment) }}원</td>
                </tr>                                      
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <!-- <div class="btn_box">
                <button class="btn btn_md btn_gray">취소</button>
                <button class="btn btn_md btn_darkblue">수정</button>
              </div> -->
            </div>            
          </div>                                 
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'OrderMngtDtl',
    mixins: [commonUtil],
    components: {

    },
    data() {
      return {
        prescribeSeq : '',
        orderPaymentInfo : {},
        selected: null,
        orderMedicineList : []
      }
    },
    created(){
            this.prescribeSeq = this.$store.getters['orderPaymentMngt/getPrescribeSeq']
            console.log("@@@@ prescribeSeq : "+this.prescribeSeq);

            this.fn_search(this.prescribeSeq);
    },
    methods : {
      fn_search(prescribeSeq){

            //주문내역seq 정보 셋팅
            let param = new Object();
            param.prescribeSeq = prescribeSeq;

            //주문내역 조회
            axios
                .post("/api/admin/orderPayment/getOderDetail", param)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.orderPaymentInfo = res.data.orderInfo;

                    console.log("@@@@ orderPaymentInfo : %o",this.orderPaymentInfo);

                    this.orderMedicineList = res.data.orderMedicineList;
                })
                .catch((err) => console.log(err));
                
        },
        fn_move_list_page(){
          this.$store.dispatch('orderPaymentMngt/setPrescribeSeq', ''); 
          this.$router.push("/admin/orderPayment/orderTangjunList");
      },
    }
  }
</script>